<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PAYMENT_TERMS.ADD_PAYMENT_TERM") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <payment-term-form
              :loading="loading"
              :paymentTermData="paymentTerm"
              :formErrors="formErrors"
              @paymentTermSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPaymentTerm from "./defaultPaymentTerm";
import PaymentTermForm from "./partials/PaymentTermForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PaymentTermForm,
  },

  mixins: [alertLeave],

  data() {
    const paymentTerm = cloneDeep(defaultPaymentTerm);
    return {
      paymentTerm: paymentTerm,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List PaymentTerms" });
    },

    viewpaymentTerm(paymentTerm) {
      this.alertLeave = false;
      this.$router.push({
        name: "View PaymentTerm",
        params: { id: paymentTerm.id },
      });
    },

    async handleSubmit(paymentTerm) {
      this.loading = true;

      const paymentTermData = cloneDeep(paymentTerm);
      delete paymentTermData.id;

      try {
        await this.$store.dispatch("paymentTerms/add", paymentTermData);
        this.$notify({
          type: "success",
          message: this.$t("PAYMENT_TERMS.PAYMENT_TERM_ADDED"),
        });
        const paymentTerm = await this.$store.getters[
          "paymentTerms/paymentTerm"
        ];
        this.viewpaymentTerm(paymentTerm);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
